/// <amd-module name="VSSUI/Components/IdentityCard/CardContactLine" />
import * as React from "react";
import { Icon } from "VSSUI/Icon";
import { Link } from "VSSUI/Link";
import { IContactLineProps } from "./ContactCard.Props";

export const CardContactLine: React.FunctionComponent<IContactLineProps> = (props: IContactLineProps) => {
    return (
        <div className="bolt-identity-default-card-contact-line-wrapper flex-row">
            <Icon iconName={props.iconName} className="bolt-identity-default-card-contact-line-label font-size" />
            {props.link && (
                <Link className="flex-row word-wrap" href={props.link} removeUnderline={true}>
                    {props.hiddenLabel && ( <span className="screen-reader-only">{props.hiddenLabel}</span>)}
                    {props.content}
                </Link>
            )}
            {!props.link && <span className="bolt-identity-default-card-contact-line-no-link word-wrap">{props.content}</span>}
        </div>
    );
};
